module.exports = __webpack_public_path__ + "img/rzs.3b7730af.png";